module.exports = __webpack_public_path__ + "static/media/icon-piece-loa-02.b940d8af.png";